import { useContainer } from '../..';
import { TimeLogApi, ToastStateHandler } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { useTranslation } from '../../useTranslation';

const useHttpDeleteUserTimeLog = () => {
    const { t } = useTranslation('newNotifications');
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (id: string, callback: ICallback) => {
        const { exec, abort } = timeLogApi.deleteUserTimelog({
            params: { id },
            onSuccess: () => {
                if (callback.onSuccess) callback.onSuccess();
                toastHandler.push('success', t('timelog.timesheetDeletion'), t('timelog.timesheetDeleteUserTimeLogSuccess'));
            },
            onError: error => {
                if (callback.onError) callback.onError();
                toastHandler.push('error', t('timelog.timesheetDeletion'), t('timelog.timesheetDeleteUserTimeLogError'));
                return error;
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpDeleteUserTimeLog;
